module.exports = __webpack_public_path__ + "static/movement-speed-6fbee5881d74e5c5897285a239e2cbd5.jpg";